export const isHaftItem = (it) => ((it?.branding?.type || "")).toLowerCase().includes("haft");

const itemDone = (it) => {
  const sd = it?.size_done || {};
  const ks = Object.keys(it?.sizes || {});
  return ks.length > 0 && ks.every((k) => sd[k]);
};

export const queueStatus = (items = []) => {
  const pr = items.filter((it) => !isHaftItem(it));
  const hf = items.filter(isHaftItem);
  return {
    hasPrint: pr.length > 0,
    hasHaft: hf.length > 0,
    printDone: pr.length > 0 && pr.every(itemDone),
    haftDone: hf.length > 0 && hf.every(itemDone),
  };
};
